import { Configuration } from '../../clients/quipli-service/configuration/configuration';
import { Label } from '../../clients/quipli-service/label/label';
import { Typography } from '../../components/typography/typography';

export const CheckoutBacklink = ({ conf, labels }: { conf: Configuration[]; labels: Label[] }) => {
  return conf.find((c) => c.variable === 'CONF_QUIPLI_BACKLINKS')?.value === '1' ? (
    <div className="mt-3 text-center">
      <a
        className="text-[var(--grey-850)] hover:text-primary-500"
        href={conf.find((c) => c.variable === 'CONF_QUIPLI_BACKLINK_URL')?.value}
        target="_blank"
        data-cy="checkout-backlink"
      >
        <Typography type="text-sm">{labels.find((l) => l.key === 'L_QUIPLI_BACKLINK_TEXT')?.caption}</Typography>
      </a>
    </div>
  ) : null;
};
